import './index.css';
import './register-stencil';

import {
    StyledEngineProvider,
    ThemeProvider,
} from '@mui/material/styles';
import { apolloMaterialUiThemeLight } from '@uipath/apollo-mui5';
import { asyncWithLDProvider } from 'launchdarkly-react-client-sdk';
import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import { LocalizationContextProvider } from './container/Localization';
import { RouterContextProvider } from './container/Router';
import IntlProvider from './locales';
import * as serviceWorker from './serviceWorker';
import { getLaunchDarklyClientIdFromEnv } from './util/EnvironmentUtil';

(async () => {
    const clientId = getLaunchDarklyClientIdFromEnv();
    const LDProvider = await asyncWithLDProvider({
        clientSideID: clientId,
        reactOptions: { useCamelCaseFlagKeys: false },
        user: {
            key: 'SharedKey',
            custom: { spaceName: 'auth0' },
        },
    });

    ReactDOM.render(
        <LDProvider>
            <StyledEngineProvider injectFirst>
                <ThemeProvider theme={apolloMaterialUiThemeLight}>
                    <RouterContextProvider>
                        <LocalizationContextProvider>
                            <IntlProvider>
                                <App />
                            </IntlProvider>
                        </LocalizationContextProvider>
                    </RouterContextProvider>
                </ThemeProvider>
            </StyledEngineProvider>
        </LDProvider>,
        document.getElementById('root'),
    );
})();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
